import { DocumentIndex } from '@/interfaces/documentIndex';
import { ListResponse } from '@/interfaces/list';
import { DocumentIndexResource, documentIndexResource } from '@/resources/documentIndex.resource';
import { EntityModule } from './entity.module';

/**
 * Moduł dokumentów z indeksu
 *
 * @export
 * @class DocumentIndexModule
 * @extends {EntityModule<DocumentIndex, DocumentIndexResource>}
 */
export class DocumentIndexModule extends EntityModule<DocumentIndex, DocumentIndexResource> {
  constructor() {
    super(documentIndexResource);
    this.state = {
      ...this.state,
      statistics: [],
      financialReport: []
    } as any;

    this.mutations = {
      ...this.mutations,

      /**
       * Zapisuje statystyki
       *
       * @param {*} localState
       * @param {*} statistics
       */
      saveStatistics(localState: any, statistics: any): void {
        localState.statistics = statistics;
      },

      /**
       * Zapisuje raport finansowy
       *
       * @param {*} localState
       * @param {*} report
       */
      saveFinancialReport(localState: any, report: any): void {
        localState.financialReport = report;
      }
    };

    this.actions = {
      ...this.actions,

      /**
       * Pobiera listę dokumentów bez kolorowania
       *
       * @param {*} context
       * @param {*} filters
       * @returns {Promise<ListResponse<DocumentIndex>>}
       */
      listNoColors: (context: any, filters: any): Promise<ListResponse<DocumentIndex>> => {
        const preventLoader = filters?.preventLoader;
        if (preventLoader) {
          filters = { ...filters, preventLoader: undefined };
        }

        return this.resource.listNoColors(filters, preventLoader).then(({ list, count }) => {
          context.commit('saveList', list);
          context.commit('saveCount', count);
          context.commit('saveFilters', filters);
          return { list, count };
        });
      },

      /**
       * Pobiera statystyki
       *
       * @param {*} options
       * @returns {Promise<*>}
       */
      getStatistics: (context: any, options: any): Promise<any> =>
        this.resource.statistics(options).then(statistics => {
          context.commit('saveStatistics', statistics);
          return statistics;
        }),

      /**
       * Pobiera raport finansowy
       *
       * @param {*} context
       * @param {*} variables
       * @returns {Promise<any>}
       */
      getFinancialReport: (context: any, variables: any): Promise<any> =>
        this.resource.financialReport(variables).then(report => {
          context.commit('saveFinancialReport', report);
          return report;
        })
    };
  }
}

export default new DocumentIndexModule();
